export default "__VITE_ASSET__9e3860f9__"